export default () => {
  //
};



// WEBPACK FOOTER //
// ./resources/js/views/home.js